import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mm_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const img = (url) => (!url ? "" : url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const money = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n || 0);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0] || ""} ${x.msg}`.trim()).join(". ");
  return String(d);
}

export const FREE_SHIPPING = 200;
export const SHIPPING_FEE = 6.95;
